import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Morachichincholi() {



    const cardData =
    {
        keyword: 'Morachi Chincholi',
        heading: 'Anand Krushi Paryatan Kendra: Morachi Chincholi',
        headingDescription: 'Morachi Chincholi is a unique agri-tourism village located around 60 km from Pune, renowned for its thriving population of peacocks and authentic rural experiences. Often called the “Village of Peacocks,” Morachi Chincholi offers a serene escape from the city with lush farms, traditional Maharashtrian food, and family-friendly activities like bullock cart rides, tractor tours, and peacock spotting. It’s an ideal one-day picnic destination near Pune, especially for families, school groups, and nature enthusiasts looking to enjoy countryside charm and cultural immersion. With its eco-tourism focus, Morachi Chincholi stands out as one of the best rural tourism spots in Maharashtra—where nature, tradition, and hospitality come together for a memorable getaway.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',

        topPlaces: [
  {
    "title": "Peacock Sanctuary & Bird Watching",
    "description": "Home to over 2,500 peafowls roaming freely among ancient tamarind trees, Morachi Chincholi offers magical wildlife encounters—especially at dawn and dusk. A top destination for bird lovers and photographers."
  },
  {
    "title": "Water Park & Rain-Dance",
    "description": "Cool off in the on-site water park featuring a swimming pool, rain-dance zone, and slides. Perfect for families to enjoy refreshing fun under the open skies of the countryside."
  },
  {
    "title": "Bullock Cart & Tractor Safaris",
    "description": "Experience authentic rural life with leisurely bullock-cart rides and tractor safaris through farmland and village roads—ideal for kids and adults seeking agritourism adventures."
  },
  {
    "title": "Adventure Sports & Outdoor Games",
    "description": "Thrilling activities like zip‑lining, rock-climbing, archery, cricket, volleyball, and badminton are set in lush, sprawling lawns—great for groups and team outings."
  },
  {
    "title": "Traditional Village Games",
    "description": "Enjoy nostalgic rural games such as gilli-danda, marbles, lagori, and kite flying. Guided by local hosts, these games offer cultural immersion and family bonding."
  },
  {
    "title": "Live Entertainment Shows",
    "description": "Catch live magic shows, puppet performances, and vibrant DJ music sessions—adding festive energy to your picnic from morning through evening."
  },
  {
    "title": "Nature Trails & Farm Walks",
    "description": "Take tranquil strolls through banana, sugarcane, and tamarind plantations. Guided walks introduce guests to organic farming and the region’s biodiversity."
  },
  {
    "title": "Healthy Maharashtrian Cuisine",
    "description": "Feast on unlimited home-style vegetarian meals including poha, misal, zunka-bhakri, chutneys, fresh buttermilk and sugarcane juice—prepared with locally sourced ingredients."
  },
  {
    "title": "Dedicated Children’s Play Zone",
    "description": "Safe play area featuring swings, slides, trampolines, and swings—perfect for younger visitors to enjoy and explore in an open, green environment."
  },
  {
    "title": "Bonfire & Night Camping",
    "description": "Extend your day with an enchanting evening around a bonfire—complete with storytelling, music, star-gazing and optional overnight stay in tents or dormitories."
  }
],




"services": [
  {
    "name": "Morachi Chincholi Sightseeing",
    "description": "Anand Krushi Paryatan Kendra is one of the top spots for sightseeing around Morachi Chincholi. Surrounded by vibrant farms, peacock habitats, and rural landscapes, it offers scenic views and immersive experiences that bring you close to village life. Whether you’re visiting for a quiet escape or capturing nature’s beauty, it’s a must-see on your Morachi Chincholi trip."
  },
  {
    "name": "Things to Do in Morachi Chincholi",
    "description": "At Anand Krushi Paryatan Kendra, there's no shortage of things to do. From bullock cart rides and tractor safaris to live farming demos and traditional cooking, the farm provides a well-rounded mix of relaxation and rural adventure. Don't miss the chance to feed animals, enjoy a farm-to-table meal, or simply unwind under the mango trees."
  },
  {
    "name": "Morachi Chincholi Bird Sanctuary",
    "description": "While Anand Krushi Paryatan Kendra is not an official bird sanctuary, it's located near Morachi Chincholi’s peacock-populated zones. The open, natural surroundings of the farm make it an excellent base for birdwatchers and nature lovers hoping to spot vibrant peacocks and other native birds in their natural habitat."
  },
  {
    "name": "Family Activities at Morachi Chincholi",
    "description": "Families visiting Anand Krushi Paryatan Kendra near Morachi Chincholi can enjoy a full day of safe, engaging, and educational experiences. Children can participate in outdoor games, animal petting, and learn about farming, while adults relax with traditional food and village hospitality—making it a perfect multi-generational outing."
  },
  {
    "name": "Adventure Options in Morachi Chincholi",
    "description": "For those seeking light adventure, Anand Krushi Paryatan Kendra offers fun rural thrills like tractor rides through the fields, interactive farming tasks, and outdoor obstacle games. It’s a great place to experience soft adventure blended with the charm of authentic rural living near Morachi Chincholi."
  },
  {
    "name": "Best Time to Visit Morachi Chincholi",
    "description": "The best time to visit Anand Krushi Paryatan Kendra near Morachi Chincholi is from November to February, when the weather is cool, the skies are clear, and peacock sightings are frequent. Summer is perfect for mango lovers, while monsoons transform the farm into a lush green haven."
  },
  {
    "name": "Photography Spots in Morachi Chincholi",
    "description": "Bring your camera! Anand Krushi Paryatan Kendra is a treasure trove for photography lovers. Capture candid moments of rural life, golden hour farmscapes, and free-roaming peacocks. The rustic architecture and natural greenery create picture-perfect frames at every turn."
  },
  {
    "name": "Morachi Chincholi Nature Trails",
    "description": "Nature enthusiasts can enjoy peaceful trails around Anand Krushi Paryatan Kendra, walking through orchards, vegetable patches, and native flora. The surrounding areas of Morachi Chincholi offer bird-watching paths and scenic routes ideal for morning or evening strolls."
  },
  {
    "name": "Eco-Tourism in Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra proudly promotes eco-tourism by practicing sustainable farming, using organic methods, and educating visitors on traditional agricultural wisdom. It's a place where tourism and conservation come together for a greener experience near Morachi Chincholi."
  },
  {
    "name": "Camping Sites Near Morachi Chincholi",
    "description": "Looking for a rustic camping experience? Anand Krushi Paryatan Kendra offers open-air spaces where visitors can set up tents or enjoy evening bonfires with folk storytelling. It’s a perfect getaway for groups or families wanting to enjoy a starlit night in the countryside."
  },
  {
    "name": "Wildlife Spotting in Morachi Chincholi",
    "description": "While peacocks are the highlight of Morachi Chincholi, visitors at Anand Krushi Paryatan Kendra may also spot other native fauna such as kingfishers, egrets, and chameleons. The farm’s natural surroundings attract a variety of birds and small wildlife, offering spontaneous encounters with nature."
  },
  {
    "name": "Local Festivals at Morachi Chincholi",
    "description": "Visiting Anand Krushi Paryatan Kendra during local festivals like Makar Sankranti or Diwali brings an added layer of charm. Guests can witness traditional dance, food fairs, and rural decorations that reflect Maharashtra's vibrant village culture."
  },
  {
    "name": "Food Spots Near Morachi Chincholi",
    "description": "Craving local flavors? Anand Krushi Paryatan Kendra offers freshly prepared Maharashtrian thalis made with ingredients from the farm. Guests can also enjoy homemade pickles, jaggery sweets, and seasonal fruits like guavas and mangoes, all while dining in a rustic village setting."
  },
  {
    "name": "Picnic Areas in Morachi Chincholi",
    "description": "Anand Krushi Paryatan Kendra is a popular picnic spot near Morachi Chincholi, offering shaded seating areas, open spaces for games, and traditional rural meals. It’s perfect for families, school groups, or anyone looking for a peaceful day out close to nature."
  },
  {
    "name": "Guided Tours in Morachi Chincholi",
    "description": "Learn and explore with guided tours at Anand Krushi Paryatan Kendra. Friendly locals explain farming methods, seasonal crops, and village traditions. Tours can also include visits to nearby temples and natural landmarks, making it a complete rural experience."
  }
],
"tableData": [
  ["Morachi Chincholi Sightseeing", "- Things to Do in Morachi Chincholi"],
  ["Morachi Chincholi Bird Sanctuary", "- Family Activities at Morachi Chincholi"],
  ["Adventure Options in Morachi Chincholi", "- Best Time to Visit Morachi Chincholi"],
  ["Photography Spots in Morachi Chincholi", "- Morachi Chincholi Nature Trails"],
  ["Eco-Tourism in Morachi Chincholi", "- Camping Sites Near Morachi Chincholi"],
  ["Wildlife Spotting in Morachi Chincholi", "- Local Festivals at Morachi Chincholi"],
  ["Food Spots Near Morachi Chincholi", "- Picnic Areas in Morachi Chincholi"],
  ["Guided Tours in Morachi Chincholi", "- "]
],



"whychoose": [
  {
    "WhyChooseheading": "Convenient Location from Pune",
    "WhyChoosedescription": "Anand Krushi Paryatan Kendra is located just 55 km from Pune, making it an ideal one-day picnic destination. Easily accessible by road, it offers a scenic countryside drive and a quick getaway from the city's hustle and bustle."
  },
  {
    "WhyChooseheading": "Peacock Watching in Natural Habitat",
    "WhyChoosedescription": "Morachi Chincholi is home to over 2,500 peacocks that roam freely in ancient tamarind groves. Visitors to Anand Krushi Paryatan can witness peacocks dancing and calling, especially during early mornings and evenings—a rare and breathtaking rural wildlife experience."
  },
  {
    "WhyChooseheading": "Authentic Village and Agritourism Experience",
    "WhyChoosedescription": "At Anand Krushi Paryatan, guests can explore the true essence of village life through bullock cart rides, tractor tours, organic farm visits, and interactions with local farmers. Engage in hands-on activities like vegetable picking and feeding farm animals for a rich, immersive experience."
  },
  {
    "WhyChooseheading": "Fun Activities for Kids and Families",
    "WhyChoosedescription": "The destination offers puppet shows, magic shows, traditional games, and animal feeding zones for children, along with family-friendly zones like play areas and relaxation spots. It’s a perfect rural retreat that entertains both kids and adults."
  },
  {
    "WhyChooseheading": "Adventure and Outdoor Sports",
    "WhyChoosedescription": "Visitors looking for excitement can enjoy zip-lining, archery, rope climbing, and boating. Open spaces allow for games like cricket and volleyball, while the rain dance arena adds a splash of fun on warm days—perfect for groups and families alike."
  },
  {
    "WhyChooseheading": "Seasonal Festivals and Cultural Events",
    "WhyChoosedescription": "Enjoy traditional seasonal events such as Hurda parties during winter and Mango Mahotsav in summer. These local festivals feature fresh farm produce, rural entertainment, and cultural programs, providing a memorable and authentic village celebration."
  },
  {
    "WhyChooseheading": "Camping, Bonfires, and Stargazing",
    "WhyChoosedescription": "Stay back to enjoy peaceful camping under the stars. Anand Krushi Paryatan offers cozy tent stays, bonfire evenings, and nature trails, giving guests a serene escape and a chance to reconnect with nature in a rustic setting."
  },
  {
    "WhyChooseheading": "Affordable All-Inclusive Packages",
    "WhyChoosedescription": "The center offers budget-friendly packages starting from ₹600 per adult and ₹300 for children. Packages include meals, farm rides, and access to all activities, making it an excellent value-for-money destination for families, school groups, and corporate outings."
  }
]




    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Where is Anand Krushi Paryatan Kendra located in Morachi Chincholi?',
    answer: 'It’s centrally located in Morachi Chincholi village, about 65 km northeast of Pune—easy to access via Alandi or Chakan.',
  },
  {
    id: 'FAQ2',
    question: 'What is Morachi Chincholi famous for?',
    answer: 'Morachi Chincholi is renowned for its peacock population, particularly observed during the monsoon. It’s also known for agritourism centers and rural charm.',
  },
  {
    id: 'FAQ3',
    question: 'What activities are available at Anand Krushi?',
    answer: 'The center offers butterfly watching, pony rides, tractor rides, farm walks, birdwatching, bullock-cart rides, rural games, and shaded picnic spots.',
  },
  {
    id: 'FAQ4',
    question: 'When is the best time to visit for peacock sightings?',
    answer: 'Monsoon through early winter (June–November) is best, when peacocks are most active and visible around farm fields.',
  },
  {
    id: 'FAQ5',
    question: 'How long should we plan to stay?',
    answer: 'Most visitors spend 3–5 hours enjoying rides, walking trails, and relaxing—perfect for a half‑day visit or a full-day picnic.',
  },
  {
    id: 'FAQ6',
    question: 'Are guided tours available?',
    answer: 'Yes. You can opt for guided nature walks and farm tours to learn about local flora, fauna, and rural farming practices.',
  },
  {
    id: 'FAQ7',
    question: 'Is photography allowed during peacock and farm visits?',
    answer: 'Absolutely! It’s a fantastic spot for nature and wildlife photography, especially with peacocks, butterflies, and rural scenes.',
  },
  {
    id: 'FAQ8',
    question: 'What should we carry for the visit?',
    answer: 'Bring comfortable clothing, sun protection, insect repellent, water bottles, and your own snacks or picnic mats if desired.',
  },
  {
    id: 'FAQ9',
    question: 'Are there restroom facilities available?',
    answer: 'Yes, clean restrooms and basic changing areas are conveniently available near the main activity zones.',
  },
  {
    id: 'FAQ10',
    question: 'Is it suitable for all age groups?',
    answer: 'Yes! With gentle walks, animal interactions, rides, and picnic spots, it’s enjoyable for toddlers to grandparents alike.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Naik, Pune',
    feedback: "Visiting Morachi Chincholi at Anand Krushi was magical. We saw dozens of peacocks, enjoyed pony rides, and the peaceful village vibe was refreshing. A must‑visit near Pune!",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Sneha Joshi, Travel Blogger',
    feedback: "Morachi Chincholi’s rural beauty and peacock sightings at Anand Krushi blew me away. The guided tour was insightful, and the setting was serene and photogenic.",
    rating: 5,
  },
];





    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Morachi Chincholi",
  "image": "https://morachichincholi.in/assets/images/morachi-chincholi.jpg",
  "description": "Experience the charm of Morachi Chincholi — a serene village near Pune known for its peacock sanctuary, eco-tourism, nature trails, and family-friendly activities. Visit Anand Krushi Paryatan Kendra for authentic rural experiences and outdoor fun.",
  "brand": {
    "@type": "Brand",
    "name": "Anand Krushi Paryatan Kendra"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "2561"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "450",
    "availability": "https://schema.org/InStock",
    "url": "https://morachichincholi.in/morachi-chincholi"
  }
};




    return (
        <div>
<Helmet>
  <title>Morachi Chincholi | Bird Sanctuary, Nature Trails & Eco-Tourism | Anand Krushi Paryatan Kendra</title>
  <meta 
    name="description" 
    content="Explore Morachi Chincholi, a peaceful destination near Pune known for peacock sightings, eco-tourism, nature trails, family fun, local food, and village experiences. Plan your visit with Anand Krushi Paryatan Kendra." 
  />
  <meta 
    name="keywords" 
    content="Morachi Chincholi sightseeing, Things to do in Morachi Chincholi, Morachi Chincholi bird sanctuary, Family activities at Morachi Chincholi, Adventure options in Morachi Chincholi, Best time to visit Morachi Chincholi, Photography spots in Morachi Chincholi, Morachi Chincholi nature trails, Eco-tourism in Morachi Chincholi, Camping sites near Morachi Chincholi, Wildlife spotting in Morachi Chincholi, Local festivals at Morachi Chincholi, Food spots near Morachi Chincholi, Picnic areas in Morachi Chincholi, Guided tours in Morachi Chincholi" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/3.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Morachichincholi;